"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.company.list': 'Empresas',
    'route.company.create': 'Agregar Empresa',
    'route.company.edit': 'Editar Empresa',
};
